import React, { Component } from 'react';
import styled from "styled-components";


const StyledHeader = styled.header`
  background-color: var(--black);
  color: white;
  font-weight: 400;
  padding-bottom: 10px;
  position: fixed; 
  top: 0; 
  width: 100%; 

  .wrapper{
    display: flex;
    justify-content: space-between;
  }

  .menu{
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .yellow{
    background: var(--yellow);
    color: var(--black);
    font-size: 20px;
    font-weight: 600;
    width: 8rem;
    padding: 10px 20px;
    text-align: left;
  }

  nav{
    margin-right: 3vw;
  }

  a{
    color: white;
    padding: 5px;
    margin: 10px;
  }

  .nomStatus{
    border: 2px solid white;
    padding: 5px;
    width: 12rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .full{
    border: 2px solid var(--yellow);
  }

  @media(max-width: 650px){
    nav{
      margin-right: 2vw;
    }
    .nomStatus{
      width: 9rem;
      height: 2.5rem;
    }
    .yellow{
      display: none;
      width: 0;
    }
    .wrapper{
    display: flex;
    justify-content: right;
    }
    a{
      margin:0px;
      margin-left: 5px;
    }
  }

  @media(max-width: 370px){
    .nomStatus{
      width: 8rem;
      text-align: center;
      font-size: 14px;
    }
    a{
      font-size: 14px;
    }
  }

`;

 
class Nav extends Component {
  render(){
    const movCount = this.props.count.length;
    let math;

    if (movCount === 4) {
      math = <p>{5 - movCount} nomination left!</p>
    }
    else if (movCount < 5) {
      math = <p>{5 - movCount} nominations left!</p>
    }
    else {
      math = <p>Nomination list full!</p>
    }

    return(
      <StyledHeader>
        <div className="wrapper">
          <div className="yellow">The Shoppies</div>
          <div className="menu">
            <nav>
              <a href="#searchIntro">Search</a>
              <a href="#nominees">Nominees</a>
              <a href="#twitterDiv">Share</a>
            </nav>
            <div className={movCount === 5 ? 'nomStatus full' : 'nomStatus'}>{math}</div>
          </div>
        </div>
      </StyledHeader>
    )
  }
}

export default Nav